// extracted by mini-css-extract-plugin
export default {"changePasswordContainer":"changePassword_changePasswordContainer__edDnC"};